// Match dates/times are stored as GMT in the DB. These helpers combine
// the stored "YYYY-MM-DD" date and "HH:MM[:SS]" time as a UTC instant
// and then format it via the browser's Intl, which picks both the
// locale and the timezone (with DST) from the user's environment.
// A kickoff stored at 18:00 GMT is rendered "20:00" by a Paris-summer
// visitor, "19:00" by a Paris-winter one, "1:00 PM" by a New York
// browser, etc., without touching the DB.

export function matchAsUtcDate(dte?: string | Date | null, hre?: string | null): Date | null {
    if (!dte) return null;

    let dateIso: string;
    if (dte instanceof Date) {
        const y = dte.getUTCFullYear();
        const m = String(dte.getUTCMonth() + 1).padStart(2, '0');
        const d = String(dte.getUTCDate()).padStart(2, '0');
        dateIso = `${y}-${m}-${d}`;
    } else if (typeof dte === 'string') {
        if (/^\d{4}-\d{2}-\d{2}/.test(dte)) {
            dateIso = dte.slice(0, 10);
        } else if (/^\d{2}\/\d{2}\/\d{4}/.test(dte)) {
            const [d, m, y] = dte.slice(0, 10).split('/');
            dateIso = `${y}-${m}-${d}`;
        } else {
            return null;
        }
    } else {
        return null;
    }

    let timeIso: string;
    if (hre && /^\d{2}:\d{2}/.test(hre)) {
        timeIso = hre.length === 5 ? `${hre}:00` : hre.slice(0, 8);
    } else {
        timeIso = '00:00:00';
    }

    const iso = `${dateIso}T${timeIso}Z`;
    const result = new Date(iso);
    return Number.isNaN(result.getTime()) ? null : result;
}

export function formatMatchDate(d: Date): string {
    return d.toLocaleDateString(undefined, {day: '2-digit', month: '2-digit', year: 'numeric'});
}

export function formatMatchTime(d: Date): string {
    return d.toLocaleTimeString(undefined, {hour: '2-digit', minute: '2-digit'});
}

export function formatMatchDateTime(d: Date): string {
    return `${formatMatchDate(d)} ${formatMatchTime(d)}`;
}

export function displayMatchDate(dte?: string | Date | null, hre?: string | null): string {
    const d = matchAsUtcDate(dte, hre);
    if (d) return formatMatchDate(d);
    if (typeof dte === 'string') return dte;
    return '';
}

export function displayMatchTime(dte?: string | Date | null, hre?: string | null): string {
    const d = matchAsUtcDate(dte, hre);
    if (d) return formatMatchTime(d);
    return hre ?? '';
}
